export const GET_WEAVECOLOR_REQUEST = 'GET_WEAVECOLOR_REQUEST';
export const GET_WEAVECOLOR_DATA = 'GET_WEAVECOLOR_DATA';
export const GET_WEAVECOLOR_ERROR = 'GET_WEAVECOLOR_ERROR';

export const CREATE_WEAVECOLOR_REQUEST = 'CREATE_WEAVECOLOR_REQUEST';
export const CREATE_WEAVECOLOR_DATA = 'CREATE_WEAVECOLOR_DATA';
export const CREATE_WEAVECOLOR_ERROR = 'CREATE_WEAVECOLOR_ERROR';

export const UPDATE_WEAVECOLOR_REQUEST = 'UPDATE_WEAVECOLOR_REQUEST';
export const UPDATE_WEAVECOLOR_DATA = 'UPDATE_WEAVECOLOR_DATA';
export const UPDATE_WEAVECOLOR_ERROR = 'UPDATE_WEAVECOLOR_ERROR';

export const DELETE_WEAVECOLOR_REQUEST = 'DELETE_WEAVECOLOR_REQUEST';
export const DELETE_WEAVECOLOR_DATA = 'DELETE_WEAVECOLOR_DATA';
export const DELETE_WEAVECOLOR_ERROR = 'DELETE_WEAVECOLOR_ERROR';
